import { render } from "./TruckIconColored.vue?vue&type=template&id=36a1bb3b"
import script from "./TruckIconColored.vue?vue&type=script&lang=js"
export * from "./TruckIconColored.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vdzeer/Projects/movesmart-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__